/**
 * ContactsIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ContactsIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M18 14.5a2.49 2.49 0 0 0 2.35-2.35q.141-.819.15-1.65a2.5 2.5 0 0 0-5 0q.009.831.15 1.65A2.49 2.49 0 0 0 18 14.5M8 15c-4.42 0-8 2.24-8 5h16c0-2.76-3.58-5-8-5m0-2a3.48 3.48 0 0 0 3.3-3.25c.131-.743.198-1.496.2-2.25a3.5 3.5 0 1 0-7 0c.002.754.069 1.507.2 2.25A3.48 3.48 0 0 0 8 13m10 3a8.4 8.4 0 0 0-1.61.15A5.63 5.63 0 0 1 18 20h6c0-2.21-2.69-4-6-4" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ContactsIcon = makeIcon('ContactsIcon', ContactsIconSvg)
